import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { PropsWithChildren, useContext } from 'react';
import { MobileMenuIcon } from '../styles';
import cx from 'classnames';
import styled from 'styled-components/macro';
import { Button } from 'src/client/components/ui/Button';

import { ActiveNestedMobileItem, HeaderContext } from '../HeaderProvider';

type Props = {
  activeNestedItem: ActiveNestedMobileItem;
  className?: string;
  icon: IconDefinition;
  menuLabel: string;
};
export const MobileExpandableMenuItem = (props: PropsWithChildren<Props>) => {
  const { activeNestedItem, children, className, icon, menuLabel } = props;
  const { activeNestedMobileMenu, setActiveNestedMobileMenu } = useContext(HeaderContext);

  return (
    <NestedMenuLink className={className}>
      <span className="clickable" onClick={() => setActiveNestedMobileMenu(activeNestedItem)}>
        <MobileMenuIcon icon={icon} width={14} />
        {menuLabel}
        <MobileMenuCaretWrapper>
          <FontAwesomeIcon icon={faChevronRight} />
        </MobileMenuCaretWrapper>
      </span>

      <div className={cx('level', { active: activeNestedMobileMenu === activeNestedItem })}>
        <BackButton onClick={() => setActiveNestedMobileMenu(null)}>
          <FontAwesomeIcon icon={faChevronLeft} className="back-icon" />
          <span>Back</span>
        </BackButton>
        {children}
      </div>
    </NestedMenuLink>
  );
};

const NestedMenuLink = styled.div`
  i {
    display: flex;
    width: 30px;
    justify-content: center;
    font-size: 2.15rem;
    margin-right: 10px;
  }

  > span {
    display: flex;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: ${(props) => props.theme.primary3};
    color: ${(props) => props.theme.headerBarPrimary2};
    padding: 10px;
    align-items: center;
  }

  a:first-of-type {
    border-top: 1px solid ${(props) => props.theme.primary3};
  }
`;

const MobileMenuCaretWrapper = styled.div`
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const BackButton = styled(Button)`
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  display: flex;
  width: 100%;
  align-items: center;
  height: 20px;
  white-space: nowrap;
  margin: 10px 0 10px 0;
  padding: 0 0 0 10px;

  .back-icon {
    margin-right: 10px;
  }
`;
